import React from 'react';
import Routes from '../../routes';
import './App.scss';

const App = () => {
  return <Routes />;
};

export default App;
